import React from "react";
import "./BrandFilterTile.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import logos from "../BrandImages"


const BrandFilterTile = ({ disabled, selected, name, onClick }) => {
  return (
    <div className={classNames({
        "filter-tile": true,
        "filter-tile--brand": true,
        "filter-tile--disabled": disabled,
        "filter-tile--selected": selected,
        })}>
      <div onClick={onClick}
        className="filter-tile__panel"        
        title={name}>
          {logos[name] ? logos[name] : <span className="filter-tile__placeholder">{name}</span>}
          <span className="filter-tile__tick"></span>
      </div>
      {name && <div className="filter-tile__label">{name}</div>}
    </div>
  );
};

BrandFilterTile.defaultProps = {
  name: null,
  disabled: false,
  selected: false
}

BrandFilterTile.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
};

export default BrandFilterTile;